import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/core/services/store";
import VueMobileDetection from "vue-mobile-detection";
import VueLoading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

Vue.config.productionTip = false;
Vue.use(Vuetify);
Vue.use(VueMobileDetection);
Vue.use(VueLoading);
Vue.use(VueToast, {
  position: "top-right",
  duration: 5000,
});

// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
window.PerfectScrollbar = PerfectScrollbar;
import ClipboardJS from "clipboard";
window.ClipboardJS = ClipboardJS;

// Vue 3rd party plugins
import i18n from "@/core/plugins/vue-i18n";
import vuetify from "@/core/plugins/vuetify";
import "@/core/plugins/portal-vue";
import "@/core/plugins/bootstrap-vue";
import "@/core/plugins/perfect-scrollbar";
import "@/core/plugins/highlight-js";
import "@/core/plugins/inline-svg";
import "@/core/plugins/apexcharts";
import "@/core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";

Vue.mixin({
  data: function () {
    return {
      ADMIN_UID: "YH1fqzL2okh7BuVO5E1Bm21MexW2",
      RESULT_SUCCESS: 1000,
      ADMIN_FUNCTION: "adminFunction",
      PAYMENT_TYPE_FREE: "Free",
      PAYMENT_TYPE_PAYPAL: "PayPal",
      PAYMENT_TYPE_PAYPAL_SANDBOX: "PayPalSandbox",
      PAYMENT_TYPE_STRIPE: "Stripe",
      PAYMENT_TYPE_STRIPE_TEST: "StripeTest",
      REFUND_FEE: 0.1,
      SERVICE_TAX: 6.5,
      SERVICE_FEE: 120,
      TEST_PREFIX: "Test-",
    };
  },
});

router.beforeEach((to, from, next) => {
  next();

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");

// Initialize Firebase
const firebaseConfig = {
  apiKey: "AIzaSyA6TBBmgB5eZgI53W4xDIy-0kDVOzq9ZXE",
  authDomain: "ticketing-app-abd3c.firebaseapp.com",
  projectId: "ticketing-app-abd3c",
  storageBucket: "ticketing-app-abd3c.appspot.com",
  messagingSenderId: "1083042436388",
  appId: "1:1083042436388:web:5c2ecb057082f7b4140fb1",
  measurementId: "G-32CC2NZZY8",
};
// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
export const firestore = getFirestore(firebaseApp);
export const firebaseAuth = getAuth(firebaseApp);
export const functions = getFunctions(firebaseApp, "europe-west1");
/*if (process.env.NODE_ENV === "development") {
  connectFunctionsEmulator(functions, '127.0.0.1', 5001)
}*/
